import {
  faLocationDot as freeFasFaLocationDot,
  faMagnifyingGlass as freeFasFaMagnifyingGlass,
  faCircle as freeFasFaCircle,
  faChevronRight as freeFasFaChevronRight,
  faChevronLeft as freeFasFaChevronLeft,
  faXmark as freeFasFaXmark,
  faCheck as freeFasFaCheck,
  faMinus as freeFasFaMinus,
  faPlus as freeFasFaPlus,
  faTag as freeFasFaTag,
  faUserEdit as freeFasFaUserEdit,
  faCrown as freeFasFaCrown,
  faGift as freeFasFaGift,
  faCalendar as freeFasFaCalendar,
  faLanguage as freeFasFaLanguage,
  faDollarSign as freeFasFaDollarSign,
  faTrash as freeFasFaTrash,
  faCopy as freeFasFaCopy,
  faFilter as freeFasFaFilter
} from '@fortawesome/free-solid-svg-icons'

import {
  faClock as freeFarFaClock
} from '@fortawesome/free-regular-svg-icons'

import {
  faApple as freeFabFaApple,
  faGooglePlay as freeFabFaGooglePlay,
  faFacebookF as freeFabFaFacebookF,
  faTwitter as freeFabFaTwitter,
  faInstagram as freeFabFaInstagram,
  faYoutube as freeFabFaYoutube
} from '@fortawesome/free-brands-svg-icons'

export default {freeFasFaLocationDot, freeFasFaMagnifyingGlass, freeFasFaCircle, freeFasFaChevronRight, freeFasFaChevronLeft, freeFasFaXmark, freeFasFaCheck, freeFasFaMinus, freeFasFaPlus, freeFasFaTag, freeFasFaUserEdit, freeFasFaCrown, freeFasFaGift, freeFasFaCalendar, freeFasFaLanguage, freeFasFaDollarSign, freeFasFaTrash, freeFasFaCopy, freeFasFaFilter, freeFarFaClock, freeFabFaApple, freeFabFaGooglePlay, freeFabFaFacebookF, freeFabFaTwitter, freeFabFaInstagram, freeFabFaYoutube}